import MenuItem from "@mui/material/MenuItem";
import type { MouseEventHandler } from "react";

export function AvailableRegionMenuItem({
  selected,
  onClick,
  label,
}: {
  label: string;
  selected: boolean;
  onClick?:
    | (MouseEventHandler<HTMLAnchorElement> &
        MouseEventHandler<HTMLSpanElement>)
    | undefined;
}) {
  return (
    <MenuItem
      sx={{ color: "text.primary" }}
      selected={selected}
      onClick={onClick}
    >
      {label}
    </MenuItem>
  );
}
